export default {"src":"/_next/static/media/TEAMS_UNSELECTED.11629cec.svg","height":17,"width":20,"blurWidth":0,"blurHeight":0};